if (!customElements.get('kj-viewport-hero')) {
  customElements.define('kj-viewport-hero', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const firstSection = document.querySelector('#MainContent > .shopify-section');
        this.toggleAttribute('data-viewport-fit', this.closest('.shopify-section') === firstSection);
        const height = this.headers.reduce((total, header) => total + header.getBoundingClientRect().height, 0);
        this.style.setProperty('--kj-header-group-height', `${height}px`);
      };
      this.observeHeaders = () => {
        this.observer.disconnect();
        this.headers = [...document.querySelectorAll('.shopify-section-group-header-group')];
        this.headers.forEach((header) => this.observer.observe(header));
        this.update();
      };
      this.observer = new ResizeObserver(this.update);
      this.observeHeaders();
      window.addEventListener('resize', this.update);
      document.addEventListener('shopify:section:load', this.observeHeaders);
      document.addEventListener('shopify:section:unload', this.observeHeaders);
      document.addEventListener('shopify:section:reorder', this.observeHeaders);
    }

    disconnectedCallback() {
      this.observer.disconnect();
      window.removeEventListener('resize', this.update);
      document.removeEventListener('shopify:section:load', this.observeHeaders);
      document.removeEventListener('shopify:section:unload', this.observeHeaders);
      document.removeEventListener('shopify:section:reorder', this.observeHeaders);
    }
  });
}
